export default {
  category_name: 'Cadeaukaart kopen',
};
